import { previewResponse, previewState } from './fixtures';

/** Runs before any app/store module. Only a studio-owned frame can select this entry. */
export function prepareStudioPreview(): boolean {
  if (typeof window === 'undefined' || window.parent === window || !window.frameElement?.hasAttribute('data-screen-builder-preview')) return false;
  const memory = new Map<string, string>([
    ['@eleplan/id_token', 'studio-preview'], ['@eleplan/access_token', 'studio-preview'],
    ['@eleplan/expires_at', String(Date.now() + 86400000)],
  ]);
  const storage = { getItem: (key: string) => memory.get(key) ?? null, setItem: (key: string, value: string) => { memory.set(key, String(value)); }, removeItem: (key: string) => { memory.delete(key); }, clear: () => memory.clear(), key: (index: number) => [...memory.keys()][index] ?? null, get length() { return memory.size; } };
  Object.defineProperty(window, 'localStorage', { value: storage });
  Object.defineProperty(window, 'sessionStorage', { value: storage });
  Object.defineProperty(window, 'indexedDB', { value: undefined });
  // No backend, device service, telemetry, socket, or external widget may run here.
  const policy = document.createElement('meta');
  policy.httpEquiv = 'Content-Security-Policy';
  policy.content = "connect-src 'none'; frame-src 'none'; form-action 'none'; media-src 'none'; img-src 'self' data: blob:";
  document.head.appendChild(policy);
  window.fetch = async (input, init) => new Response(JSON.stringify(previewResponse(typeof input === 'string' ? input : input instanceof URL ? input.href : input.url, init?.method || (input instanceof Request ? input.method : 'GET'))), { status: 200, headers: { 'Content-Type': 'application/json' } });
  const blocked = () => { throw new Error('Unavailable in screen preview'); };
  const OriginalXHR = window.XMLHttpRequest;
  window.XMLHttpRequest = class extends OriginalXHR { send() { blocked(); } };
  window.WebSocket = class { constructor() { blocked(); } } as any;
  window.EventSource = class { constructor() { blocked(); } } as any;
  if (navigator.sendBeacon) navigator.sendBeacon = () => false;
  (window as any).__ELEPLAN_STUDIO_PREVIEW__ = { seedState: previewState };
  return true;
}
